import { useMediaQuery } from '@mui/material';

export const useResponsiveStyles = () => {
  const isDesktopLarge = useMediaQuery('(min-width: 1920px)');
  const isDesktopMedium = useMediaQuery('(min-width: 1440px) and (max-width: 1919px)');
  const isDesktopSmall = useMediaQuery('(min-width: 1200px) and (max-width: 1439px)');
  const isDesktopExtraSmall = useMediaQuery('(min-width: 992px) and (max-width: 1199px)');

  const getFontSize24 = () => {
    if (isDesktopLarge) return '28px';
    if (isDesktopMedium) return '24px';
    if (isDesktopSmall) return '20px';
    if (isDesktopExtraSmall) return '16px';
    return '15px';
  };

  const getFontSize16 = () => {
    if (isDesktopLarge) return '20px';
    if (isDesktopMedium) return '16px';
    if (isDesktopSmall) return '14px';
    if (isDesktopExtraSmall) return '12px';
    return '12px';
  };

  const getFontSize14 = () => {
    if (isDesktopLarge) return '17px';
    if (isDesktopMedium) return '14px';
    if (isDesktopSmall) return '13px';
    if (isDesktopExtraSmall) return '12px';
    return '11px';
  };

  const getFontSize13 = () => {
    if (isDesktopLarge) return '15px';
    if (isDesktopMedium) return '13px';
    if (isDesktopSmall) return '11px';
    if (isDesktopExtraSmall) return '10px';
    return '9px';
  };


  const getFontSize12 = () => {
    if (isDesktopLarge) return '15px';
    if (isDesktopMedium) return '12px';
    if (isDesktopSmall) return '11px';
    if (isDesktopExtraSmall) return '10px';
    return '9px';
  };

  const getFontSize11 = () => {
    if (isDesktopLarge) return '14px';
    if (isDesktopMedium) return '11px';
    if (isDesktopSmall) return '10px';
    if (isDesktopExtraSmall) return '9px';
    return '8px';
  };


  const getFontSize18 = () => {
    if (isDesktopLarge) return '22px';
    if (isDesktopMedium) return '18px';
    if (isDesktopSmall) return '16px';
    if (isDesktopExtraSmall) return '16px';
    return '14px';
  };

  const getFontSize9 = () => {
    if (isDesktopLarge) return '11px';
    if (isDesktopMedium) return '9px';
    if (isDesktopSmall) return '8px';
    if (isDesktopExtraSmall) return '7px';
    return '8px';
  };

  const getListAvatarSize40 = () => {
    if (isDesktopLarge) return '50px';
    if (isDesktopMedium) return '40px';
    if (isDesktopSmall) return '36px';
    if (isDesktopExtraSmall) return '30px';
    return '30px';
  };

  const getPaddingListItem = () => {
    if (isDesktopLarge) return '10px 20px';
    if (isDesktopMedium) return '8px 16px';
    if (isDesktopSmall) return '6px 12px';
    if (isDesktopExtraSmall) return '6px 12px';
    return '6px 12px';
  };

  const getPaddingFilterMenuItem = () => {
    if (isDesktopLarge) return '10px 20px';
    if (isDesktopMedium) return '6px 12px';
    if (isDesktopSmall) return '5px 10px';
    if (isDesktopExtraSmall) return '4px 8px';
    return '3px 6px';
  };

  const getIconSize20 = () => {
    if (isDesktopLarge) {
      return '23px';
    }
    if (isDesktopMedium) {
      return '20px';
    }
    if (isDesktopSmall) {
      return '18px';
    }
    if (isDesktopExtraSmall) {
      return '16px';
    }
    return '15px';
  };
  const getincrementButtonSize = () => {
    if (isDesktopLarge) {
      return '30px';
    }
    if (isDesktopMedium) {
      return '24px';
    }
    if (isDesktopSmall) {
      return '22px';
    }
    if (isDesktopExtraSmall) {
      return '18px';
    }
    return '15px';
  };
  const getincrementIconSize = () => {
    if (isDesktopLarge) {
      return '20px';
    }
    if (isDesktopMedium) {
      return '14px';
    }
    if (isDesktopSmall) {
      return '12px';
    }
    if (isDesktopExtraSmall) {
      return '8px';
    }
    return '8px';
  };

  const getAvatarIcon24 = () => {
    if (isDesktopLarge) {
      return '37px';
    }
    if (isDesktopMedium) {
      return '30px';
    }
    if (isDesktopSmall) {
      return '27px';
    }
    if (isDesktopExtraSmall) {
      return '22px';
    }
    return '20px'; // Default value
  };
  

  const getListHoverTextWithIconWidth180 = () => {
    if (isDesktopLarge) {
      return '200px';
    }
    if (isDesktopMedium) {
      return '150px';
    }
    if (isDesktopSmall) {
      return '100px';
    }
    if (isDesktopExtraSmall) {
      return '80px';
    }
    return '80px'; // Default value
  };
  

  const getHoverResumeButtonWidth = () => {
    if (isDesktopLarge) {
      return '100px';
    }
    if (isDesktopMedium) {
      return '80px';
    }
    if (isDesktopSmall || isDesktopExtraSmall) {
      return '34px';
    }
    return '34px'; // Default value
  };

  const getJobDetailsWidth400 = () => {
    if (isDesktopLarge) {
      return 500;
    }
    if (isDesktopMedium) {
      return 400;
    }
    if (isDesktopSmall) {
      return 280;
    }
    return 200; // Default value
  };
  

  const getResumeListRoleWidth = () => {
    if (isDesktopLarge) {
      return '150px';
    }
    if (isDesktopMedium) {
      return '130px';
    }
    if (isDesktopSmall) {
      return '100px';
    }
    if (isDesktopExtraSmall) {
      return '90px';
    }
    return '90px'; // Default value
  };
  

  const getResumeListTimeWidth = () => {
    if (isDesktopLarge) {
      return '75px';
    }
    if (isDesktopMedium) {
      return '65px';
    }
    if (isDesktopSmall) {
      return '55px';
    }
    if (isDesktopExtraSmall) {
      return '50px';
    }
    return '50px'; // Default value
  };
  

  const getListToolbarPadding = () => {
    if (isDesktopLarge) {
      return '0px 28px !important';
    }  if (isDesktopMedium) {
      return '0px 24px !important';
    }  if (isDesktopSmall) {
      return '0px 18px !important';
    }  if (isDesktopExtraSmall) {
      return '0px 16px !important';
    } 
      return '0px 16px'; // Default value for other screen sizes
    
  };

  const getListToolbarMinHeight = () => {
    if (isDesktopLarge) {
      return '52px !important';
    }  if (isDesktopMedium) {
      return '48px !important';
    }  if (isDesktopSmall) {
      return '40px !important';
    }  if (isDesktopExtraSmall) {
      return '38px !important';
    } 
      return '37px';
    
  };

  const getresumeSearchtitleWidth = () => {
    if (isDesktopLarge) {
      return '240px';
    }  if (isDesktopMedium) {
      return '200px';
    }  if (isDesktopSmall) {
      return '160px';
    }  if (isDesktopExtraSmall) {
      return '140px';
    }  
      return '140px'; // Default value for other screen sizes
    
  };

  const getResumeProfileAvatar100 = () => {
    if (isDesktopLarge) {
      return '120px';
    }  if (isDesktopMedium) {
      return '100px';
    } if (isDesktopSmall) {
      return '80px';
    }  if (isDesktopExtraSmall) {
      return '60px';
    } 
      return '70px'; // Default value for other screen sizes
    
  };
  

  const getheightJFI = () => {
    if (isDesktopLarge) {
      return '600px';
    }  if (isDesktopMedium) {
      return '500px';
    }  if (isDesktopSmall) {
      return '360px';
    }  if (isDesktopExtraSmall) {
      return '270px';
    }  
      return '300px'; // Default value for other screen sizes
    
  };

  const getwidthJFI = () => {
    if (isDesktopLarge) {
      return '550px';
    }  if (isDesktopMedium) {
      return '450px';
    }  if (isDesktopSmall) {
      return '320px';
    }  if (isDesktopExtraSmall) {
      return '230px';
    }  
      return '250px'; // Default value for other screen sizes
    
  };

  return {
    fontSize16: getFontSize16(),
    fontSize12: getFontSize12(),
    fontSize24: getFontSize24(),
    fontSize14: getFontSize14(),
    fontSize11: getFontSize11(),
    fontSize18: getFontSize18(),
    fontSize9: getFontSize9(),
    fontSize13: getFontSize13(),
    Avatar40: getListAvatarSize40(),
    paddingListItem: getPaddingListItem(),
    icon20: getIconSize20(),
    avatarIcon24: getAvatarIcon24(),
    incrementButtonSize: getincrementButtonSize(),
    incrementIconSize: getincrementIconSize(),
    listHoverTextWithIconWidth180: getListHoverTextWithIconWidth180(),
    resumeHoverButton: getHoverResumeButtonWidth(),
    jobDetailsWidth400: getJobDetailsWidth400(),
    resumeListRoleWidth: getResumeListRoleWidth(),
    resumeListTimeWidth: getResumeListTimeWidth(),
    listToolbarPadding: getListToolbarPadding(),
    minHeightListToolbar: getListToolbarMinHeight(),
    widthListResumeSearchTitle: getresumeSearchtitleWidth(),
    resumeProfileAvatar100: getResumeProfileAvatar100(),
    paddingFilterMenuItem: getPaddingFilterMenuItem(),
    heightJFI: getheightJFI(),
    widthJFI: getwidthJFI(),
  };
};
